import styled from 'styled-components'
import ConfirmButtonOriginal from 'components/Buttons/ConfirmButton'

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  
  padding: 25px 25px 68px;
  padding-top: calc(25px + max(var(--native-safe-area-top, 0px), env(safe-area-inset-top, 0px)));
  padding-bottom: calc(68px + env(safe-area-inset-bottom, 0px));
  overflow-y: hidden;
  
  background-color: #eef3f6;
  box-sizing: border-box;
  justify-content: stretch;
  position: relative;
`

export const ProgressHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`

export const FooterContainer = styled.div`
	position: fixed;
	bottom: 20px;
	bottom: calc(20px + env(safe-area-inset-bottom, 0px));
	left: 0;
	right: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  &.singleButton {
  	justify-content: center;
  }
  .gradient {
    margin-right: 20px;
  }
`

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #224858;
  margin-top: 1em;
  h1 {
    margin: 10px 0;
    max-width: 70%;
    line-height: 1em;
  }
`
export const ChildContainer =  styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display:none;
}
`

export const Divider = styled.div`
  border-top: 1px solid #cbe1ea;
  width: 100%;
  margin: 10px 0;
`

export const ConfirmButton = styled(ConfirmButtonOriginal)`
	padding: 8px 20px;
`
